<template>
  <div>
    <!--输入表单区域-->
    <wt-form-inputs
      v-if="form.formInputsData && form.formInputsData.length > 0 && !form.hideSearch"
      :form.sync="form"
      @request-form-list="requestFormList"
      @search-change-event="$emit('search-change-event', $event)"
      @to-reset="$emit('to-reset')"></wt-form-inputs>
    <!--按钮区域-->
    <!--<wt-form-buttons v-if="!$slots.wtFormButtons" :form.sync="form" @request-form-list="requestFormList" @on-button-action="onButtonAction">-->
    <!--</wt-form-buttons>-->
    <!--<slot name="wtFormButtons"/>-->
    <!--数据列表区域-->
    <div class="wrap" v-if="!$slots.wtFormTableList" style="display: flex;">
      <slot name="wtFormTableLeft"/>
      <wt-form-table-list ref="wtFormTableList" :form.sync="form" @request-form-list="requestFormList" @on-button-action="onButtonAction">
        <template slot="tableTopCustom">
          <slot name="tableTopCustom" />
        </template>
      </wt-form-table-list>
      <slot name="wtFormTableRight"/>
    </div>
    <slot name="wtFormInputs"/>
    <slot name="wtFormTableList"/>
    <!--分页控件区域-->
    <wt-form-pagination :form.sync="form"  v-if="!form.hidePage" @request-form-list="requestFormList">
    </wt-form-pagination>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'wt-form-table',
  props: ['form', 'is-buttons-hide'],
  data() {
    return {
    }
  },
  created() {
    if (this.form) {
      this.requestFormList()
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      this.$emit('on-button-action', data)
    },
    openView(row, item) {
      this.$refs.wtFormTableList.toView(item, row)
    },
    openEdit(row, item) {
      this.$refs.wtFormTableList.toEdit(item, row)
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestFormList() {
      if (this.form.noRequest) {
        return
      }
      if (this._events && this._events['request-form-list']) {
        this.$emit('request-form-list')
        return
      }
      const url = (this.form.formComponent && this.form.formComponent.list ? this.form.formComponent.list.value : '')
      const that = this
      const data = that.$wtUtil.toFormData(that.form)
      if (this.form.formComponent.list) {
        if (this.form.formComponent.list.params && typeof this.form.formComponent.list.params === 'function') {
          data.formData = Object.assign({}, data.formData, this.form.formComponent.list.params())
        } else if (this.form.formComponent.list.params) {
          data.formData = Object.assign({}, data.formData, this.form.formComponent.list.params)
        }
      }
      // 只给商品积分用
      if (data.formData.goodsRange) {
        data.formData.goodsMinInventory = data.formData.goodsRange[0]
        data.formData.goodsMaxInventory = data.formData.goodsRange[1]
      }
      that.form.isFormLoading = true
      request({
        url: url,
        method: 'post',
        data: that.form.hidePage ? data.formData : data
      }).then(response => {
        if (that.form.hidePage) {
          that.form.formResult.list = response.data
        } else {
          that.form.formResult = response.data
        }
        that.form.isFormLoading = false
      }).catch(() => {
        that.form.isFormLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
